import React, { useRef, useState } from 'react'
import PageLayout from '@layouts/PageLayout'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import {
  Button,
  Input,
  Dropdown,
  message,
  Popconfirm,
  Space,
  Table,
} from 'antd'

import Fetch from '@components/CRUD/Fetch'
import { EllipsisOutlined } from '@ant-design/icons'
import Create from './Create'
import Edit from './Edit'
import { client } from '@utils/client'
import Text from '@components/Text'
const List = () => {
  const { t } = useLocalization()
  const style = {
    btnAddData: { borderRadius: '5px', width: '165px', height: '40px' },
    divSearch: { width: '100%', display: 'flex', gap: '20px' },
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)

  const [modalCreateOpen, setModalCreateOpen] = useState(false)
  const [modalEditOpen, setModalEditOpen] = useState(false)
  const [defaultValues, setDefaultValues] = useState({})
  const [keyword, setKeyword] = useState()

  const fetch = async ({ page, pageSize }) => {
    const result = await client
      .get('/reward', {
        params: {
          page: page,
          limit: pageSize,
          keyword: keyword,
        },
      })
      .then((res) => res.data)

    return result
  }

  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const columns = [
    {
      title: t('rewards.list.column.no'),
      // dataIndex: 'no',
      key: 'no',
      width: 75,
      render: function no(_text, _record, index) {
        return <p>{pageSize * (page - 1) + index + 1}</p>
      },
    },
    {
      title: t('rewards.list.column.shop'),
      // dataIndex: 'shopId',
      key: 'shop',
      width: 192,
      render: function shop(dataRow) {
        return dataRow.shop.name
      },
    },
    {
      title: t('rewards.list.column.bannerImage'),
      dataIndex: 'bannerImage',
      key: 'bannerImage',
      width: 122,
      render: function bannerImageUrl(text) {
        return <img src={text} alt={text} width={76} />
      },
    },
    {
      title: t('rewards.list.column.shortDesc'),
      dataIndex: 'shortDesc',
      key: 'shortDesc',
      width: 253,
    },
    {
      title: t('rewards.list.column.desc'),
      dataIndex: 'desc',
      key: 'desc',
      width: 266,
    },
    {
      title: t('rewards.list.column.code'),
      // dataIndex: 'code',
      key: 'code',
      width: 167,
      render: function code(rowData) {
        return (
          <a
            href={`rewards-list/codeDetail/${rowData.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('rewards.list.column.codeShow')}
          </a>
        )
      },
    },
    {
      title: t('rewards.list.column.pointUsage'),
      dataIndex: 'pointUsage',
      key: 'pointUsage',
      width: 113,
    },
    {
      title: t('rewards.list.column.totalAmount'),
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      width: 161,
    },
    {
      title: t('rewards.list.column.usablePerBill'),
      dataIndex: 'usablePerBill',
      key: 'usablePerBill',
      width: 179,
    },
    {
      title: t('rewards.list.column.availableAt'),
      dataIndex: 'availableAt',
      key: 'availableAt',
      width: 278,
      render: function availableAt(dataRow) {
        return (
          <div>
            <ul style={{ padding: 0 }}>
              {dataRow.map((value, index) => {
                return <li key={index}>{value}</li>
              })}
            </ul>
          </div>
        )
      },
    },
    {
      title: t('rewards.list.column.availableSinceToUntil'),
      //dataIndex: 'usableSince',
      key: 'availableSinceToUntil',
      width: 175,
      render: function status(dataRow) {
        return (
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            <li>เริ่มต้น : {dataRow.availableSince}</li>
            <li>สิ้นสุด : {dataRow.availableUntil}</li>
          </ul>
        )
      },
    },
    {
      title: t('rewards.list.column.usableSinceToUntil'),
      key: 'usableSinceToUntil',
      width: 175,
      render: function status(dataRow) {
        return (
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            <li>เริ่มต้น : {dataRow.usableSince}</li>
            <li>สิ้นสุด : {dataRow.usableUntil}</li>
          </ul>
        )
      },
    },
    {
      title: t('rewards.list.column.status'),
      dataIndex: 'usableStatus',
      key: 'usableStatus',
      width: 141,
      render: function status(usableStatus) {
        let color = ''
        let text = ''
        if (usableStatus === 'available') {
          //available
          color = '#5BBD94'
          text = 'ใช้งานได้'
        } else if (usableStatus === 'unavailable') {
          color = '#818181'
          text = 'ใช้แล้ว'
        } else if (usableStatus === 'expired') {
          color = '#D5462D'
          text = 'หมดอายุแล้ว'
        }
        return <p style={{ color: color, fontWeight: 'bold' }}>{text}</p>
      },
    },
    {
      title: '',
      // dataIndex: 'edit',
      key: 'edit',
      width: 61,
      render: function rewardListEvent(rowData) {
        const items = [
          {
            key: '1',
            label: (
              <a
                onClick={() => {
                  setModalEditOpen(true)
                  setDefaultValues(rowData)
                }}
              >
                <Text type="primary">{t('rewards.listOperation.edit')}</Text>
              </a>
            ),
          },

          {
            type: 'divider',
          },

          {
            key: '2',
            label: (
              <div>
                <Popconfirm
                  placement="left"
                  title={t('rewards.listOperation.deleteConfirmQuestion')}
                  okText={t('rewards.listOperation.okText')}
                  cancelText={t('rewards.listOperation.cancelText')}
                  onConfirm={() => onDelete(rowData.id)}
                >
                  <a href="#">
                    <Space
                      style={{
                        width: '100%',
                        color: '#56B9C3',
                        justifyContent: 'center',
                      }}
                    >
                      {t('rewards.listOperation.delete')}
                    </Space>
                  </a>
                </Popconfirm>
              </div>
            ),
          },
        ]
        return (
          <>
            <div>
              <Dropdown
                menu={{
                  items,
                }}
                trigger="click"
              >
                <EllipsisOutlined
                  style={{ fontSize: '32px', color: '#005596' }}
                />
              </Dropdown>
            </div>
          </>
        )
      },
    },
  ]
  const handleReload = () => {
    fetchRef.current.reload()
  }
  const onDelete = async (id) => {
    try {
      await client.delete(`/reward/${id}`)
      message.success(t('rewards.listOperation.deleteSuccess'))
      handleReload()
    } catch (e) {
      message.error(t('rewards.listOperation.deleteFailed'))
    }
  }

  return (
    <PageLayout
      title={t('rewards.list.listScreen.title')}
      shownBack={false}
      extra={[
        <Button
          type="primary"
          key="reload"
          icon=""
          onClick={() => setModalCreateOpen(true)}
          style={style.btnAddData}
        >
          {t('rewards.list.addData')}
        </Button>,
      ]}
    >
      <div style={style.divSearch}>
        <SearchInput fetchData={(keyword) => setKeyword(keyword)} />
      </div>
      <Fetch fetch={fetch} params={{ page, pageSize }} ref={fetchRef}>
        {({ data, total }) => (
          <PageLayout shownBack={false}>
            <div>
              <Table
                scroll={{ x: 2560 }}
                rowKey="id"
                onChange={handleChange}
                columns={columns}
                dataSource={data}
                pagination={{
                  defaultCurrent: defaultPageSize,
                  defaultPageSize: defaultPageSize,
                  current: page,
                  pageSize,
                  total,
                }}
              />
            </div>
          </PageLayout>
        )}
      </Fetch>

      <Create
        modalCreateOpen={modalCreateOpen}
        setModalCreateOpen={setModalCreateOpen}
        defaultValue={{ availableAt: [''] }}
      />
      <Edit
        modalEditOpen={modalEditOpen}
        setModalEditOpen={setModalEditOpen}
        defaultValues={defaultValues}
      />
    </PageLayout>
  )
}

const SearchInput = ({ fetchData }) => {
  const { t } = useLocalization()
  const [keyword, setKeyword] = useState()
  const style = {
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Input
        defaultValue={keyword}
        placeholder=""
        style={style.inputSearch}
        onChange={(e) => setKeyword(e.target.value)}
      />

      <Button
        style={style.btnSearch}
        type="primary"
        key="reload"
        onClick={() => fetchData(keyword)}
      >
        {t('rewards.list.search')}
      </Button>
    </>
  )
}

SearchInput.propTypes = {
  fetchData: PropTypes.func,
}
export default List
